<template>
  <EdroneModal
    :open="show"
    :close-on-esc-key-press="true"
    :close-on-outside-click="true"
    :show-close-icon="true"
    :width="500"
    unique-id=""
    @close="emit('close')"
  >
    <template #title>{{ trans._packageManager.pricing.title }}</template>
    <p class="tw:body-2 tw:mb-4 tw:text-default-700">
      {{ trans._packageManager.pricing.description }}
    </p>
    <EdroneTable v-if="packages" class="tw:mb-4">
      <thead>
        <tr>
          <th>{{ trans._packageManager.pricing.table.columns.package }}</th>
          <th style="width: 150px" class="tw:text-right">
            {{ trans._packageManager.pricing.table.columns.price }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pck in packages.tierPrices" :key="pck.price">
          <td style="height: 48px">
            <div class="tw:flex tw:gap-2 tw:items-center">
              <p class="tw:body-1 tw:whitespace-nowrap">
                {{ formatNumberV2(pck.fromUnits) }}{{ pck.upToUnits ? ` - ${formatNumberV2(pck.upToUnits)}` : " +" }}
              </p>
              <EdroneBadge
                v-if="recommendedPrice === pck.price"
                type="violet"
                :label="trans._packageManager.pricing.recommended"
                size="small"
                icon="fa-solid fa-sparkles"
              ></EdroneBadge>
            </div>
          </td>
          <td style="height: 48px" class="tw:text-right">
            <p class="tw:body-1--bold">
              {{ formatNumberV2(pck.price, { style: "currency", currency: packages?.currency }) }}
            </p>
          </td>
        </tr>
      </tbody>
    </EdroneTable>
    <div class="tw:flex tw:gap-2">
      <EdroneButton class="tw:flex-1" type="outline" @click="emit('close')">
        {{ trans._packageManager.pricing.buttons.close }}
      </EdroneButton>
    </div>
  </EdroneModal>
</template>

<script setup lang="ts">
import EdroneButton from "edrone-components/EdroneButton.vue";
import EdroneTable from "edrone-components/EdroneTable.vue";
import EdroneModal from "edrone-components/EdroneModal.vue";
import { formatNumberV2 } from "vue-app/utils/functions.ts";
import EdroneBadge from "edrone-components/EdroneBadge/EdroneBadge.vue";
import { DTOPriceTiersResponse } from "vue-app/api/dto.d";

interface Props {
  show: boolean;
  packages?: DTOPriceTiersResponse;
  recommendedPrice?: number;
}

interface Emits {
  (event: "close"): void;
}

withDefaults(defineProps<Props>(), {
  show: false,
});

const emit = defineEmits<Emits>();
</script>
